

const hslToHex = require('../hsl/toHex');

module.exports = (hsl, number) => {
  let colors = [];
  let diff = 1 / ~~number;
  while (number--) {
    let newSat = hsl.sat - diff;
    hsl.sat = newSat >= 0 ? newSat % 1 : newSat + 1;
    colors.push(`#${hslToHex(hsl)}`);
  }
  return colors;
};


// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/internal/cycleSat.js